import { useNavigate, useRouterState } from '@tanstack/react-router'
import { Button } from '@heroui/react'
import { useTranslations } from 'use-intl'
import { clearDiscoverySelection } from '../../lib/filter-state'

const BUDGET_OPTIONS = [
  { label: '~¥3,000', value: 3000 },
  { label: '~¥5,000', value: 5000 },
  { label: '~¥10,000', value: 10000 },
  { label: '~¥20,000', value: 20000 },
]

export function BudgetFilter() {
  const navigate = useNavigate()
  const searchParams = useRouterState({ select: (s) => s.location.search })
  // @ts-ignore dynamic schema matching
  const currentBudget = searchParams.budget as number | undefined
  const t = useTranslations('discovery')

  const toggleBudget = (value: number) => {
    navigate({
      search: (prev: any) => ({
        ...clearDiscoverySelection(prev),
        budget: prev.budget === value ? undefined : value,
      }),
      replace: true,
    } as any)
  }

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-semibold text-stone-500 uppercase tracking-wider">{t('budget')}</span>
      <div className="flex flex-wrap gap-2">
        {BUDGET_OPTIONS.map((option) => {
          const isActive = currentBudget === option.value
          return (
            <Button
              key={option.value}
              size="sm"
              // @ts-expect-error
              variant={isActive ? 'solid' : 'bordered'}
              color={isActive ? 'primary' : 'default'}
              radius="full"
              onPress={() => toggleBudget(option.value)}
              className={`min-h-11 ${isActive ? 'shadow-md shadow-primary/20' : 'border-stone-200 dark:border-stone-700'}`}
              data-testid={`budget-filter-${option.value}`}
            >
              <span className={isActive ? 'font-bold' : ''}>{option.label}</span>
            </Button>
          )
        })}
      </div>
    </div>
  )
}
